
import styled from 'styled-components'

import Image from '../Image'
export default function EqiupItem ({onClick,eqiup,checked}) {
  return  <Item
  onClick={onClick}
  active={checked}
>
  {/* <Title>
    {new Array(eqiup.equip.level || 0).fill("").map((e, i) => (
      <img key={i} src="/image/foot.png" width={8} alt="foot" />
    ))}{" "}
    {eqiup.name || eqiup.id}
  </Title> */}
  <ImageWrapper>
    <Image  height={"13.8rem"} width={"100%"} src={eqiup.img} alt={eqiup.id} />
  </ImageWrapper>
  {/* <Code>
    #{eqiup.id}
  </Code> */}
</Item>
}

const Item = styled.div`
  text-align: center;
  background: #ffffff;
  /* border: 2px solid ${(props) => props.active ? '#FC9043':'#000000'}; */

  box-shadow: 2px 1px 1px 2px ${(props) => props.active ? '#000':'#fff'};
  overflow: hidden;

  border-radius: 2.2rem;

`;
const Title = styled.div`
  margin: 0 auto ;
  background: #f4f5f6;
  /* border-radius: .0rem .0rem 1.0rem 1.0rem; */
  padding: .6rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.3rem;
  color: #000000;
`;

const ImageWrapper = styled.div`
  min-height: 6.0rem;
  /* img {
    width: 50%;
  } */
`;

const Code = styled.div`
  font-family: "Anybody";
  font-style: italic;
  font-weight: 500;
  font-size: 1.4rem;
  line-height: 1.4rem;
  color: #000000;
  /* border: 1px solid #000000; */
  border-radius: 1.9rem;
  min-width: 11.0rem;
  padding: .5rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 1.0rem;
`;

